export default "__VITE_ASSET__DSJvTIBR__"